import React, {Component} from 'react';
import {close_popup, show_popup} from "../functions";

class PopupWithGoBack extends Component {
    constructor(props) {
        super(props);
        this.goBack = this.goBack.bind(this);
    }

    goBack() {
        close_popup();
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <div className="row m-3">
                        <div className="col-12 text-center" dangerouslySetInnerHTML={{__html: this.props.message}} />
                    </div>
                    <div className="row mx-3 mb-3">
                        <div className="go-btn go-back mx-auto" onClick={this.goBack} />
                    </div>
                </div>
            </div>
        )
    }
}

export default PopupWithGoBack;

export function showPopupWithGoBack(msg) {
    show_popup(<PopupWithGoBack message={msg}/>, {auto_close: false});
}